import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import _ from 'lodash';
import ToastHelper from 'general/helpers/ToastHelper';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';

DialogReportErrorChargePointView.propTypes = {
  item: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogReportErrorChargePointView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    let param = {
      reason,
      status: ChargeConstants.ChargePointStatus.FAULT,
    };
    param = _.omitBy(param, (value) => _.isEmpty(value) || _.isNil(value));
    setLoading(true);
    const result = await ChargeHelper.API.requestUpdateChargePoint(item?.pointId, param);
    if (result && _.isBoolean(result)) {
      ToastHelper.showSuccess('Báo lỗi trụ sạc thành công');
      if (onDone) {
        onDone();
      }
    } else {
      ToastHelper.showError(result || 'Báo lỗi trụ sạc thất bại');
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center px-5 pt-6 gap-2">
        <div className="mb-4">
          <img src={AppResource.images.dialogIcons.dialogReportChargePoint} />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Báo lỗi trụ sạc
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Trụ sạc phát sinh lỗi, vui lòng nhập mô tả để thông báo lỗi này tới đội ngũ bảo trì kỹ
          thuật.
        </span>
      </div>

      <div className="row m-0 p-0 px-3 mt-4">
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Lý do')}
            <KTFormTextArea
              placeholder="Nhập lý do"
              name="reason"
              value={reason}
              onChange={(value) => {
                setReason(value);
              }}
              rows={4}
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildRedButton('Báo lỗi', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogReportErrorChargePointView;
